import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { WishlistContext } from '../../context/WishlistContext';
import { API_URL } from '../../config';
import { getValidImageUrl } from '../../utils/getImageUrl';

const MyWishlist = () => {
  const { wishlistItems, removeFromWishlist } = useContext(WishlistContext);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-[24px] font-bold text-white mb-1">My Wishlist</h1>
        <p className="text-[14px] text-on-surface-variant">
          Track and manage your favorite Expert Advisors.
        </p>
      </div>

      {wishlistItems.length === 0 ? (
        <div className="bg-surface-container border border-white/5 rounded-3xl p-16 text-center flex flex-col items-center justify-center shadow-lg">
          <span className="material-symbols-outlined text-[32px] text-on-surface-variant mb-6">heart_broken</span>
          
          <p className="text-[14px] text-on-surface-variant mb-6">
            Your wishlist is empty.
          </p>
          
          <Link to="/marketplace" className="bg-primary text-[#131418] font-bold px-8 py-3 rounded-full text-[14px] hover:shadow-[0_0_15px_rgba(240,185,11,0.4)] hover:-translate-y-0.5 transition-all duration-300">
            Explore Marketplace
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {wishlistItems.map((item) => (
            <div key={item.product_id} className="bg-surface-container border border-white/5 rounded-2xl overflow-hidden hover:border-primary/30 transition-colors shadow-lg flex flex-col">
              <div className="aspect-video relative overflow-hidden bg-black/20">
                <img src={item.image ? getValidImageUrl(item.image) : `https://ui-avatars.com/api/?name=${encodeURIComponent(item.name)}&background=18191d&color=fff&size=512`} alt={item.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <button 
                  onClick={(e) => { e.preventDefault(); removeFromWishlist(item.product_id); }}
                  className="absolute top-4 right-4 w-10 h-10 rounded-full bg-black/50 backdrop-blur text-[#EF4444] flex items-center justify-center hover:bg-black/70 transition-colors border border-white/10 z-10"
                  aria-label="Remove from Wishlist"
                >
                  <span className="material-symbols-outlined text-[20px] font-bold filled">heart_broken</span>
                </button>
              </div>
              <div className="p-5 flex flex-col flex-grow">
                <h3 className="font-bold text-white text-[16px] mb-2">{item.name}</h3>
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-primary font-bold text-[16px]">${item.newPrice}</span>
                  {item.price && item.price !== item.newPrice && (
                    <span className="text-on-surface-variant text-[13px] line-through">${item.price}</span>
                  )}
                </div>
                <div className="mt-auto">
                  <Link to={`/ea/${item.product_id}`} className="w-full block text-center bg-white/5 text-silver-text hover:bg-white/10 border border-white/10 font-bold px-4 py-2.5 rounded-xl text-[13px] transition-colors">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyWishlist;
